import { Bell } from 'lucide-react'
import NoticeListItem from './NoticeListItem'
import type { NoticeListItem as NoticeListItemType } from '@/api/model/noticeType'

const NoticeListScreen = ({
  loading,
  notices,
  unreadCount,
  handleClickNotice
}: {
  loading: boolean
  notices: NoticeListItemType[]
  unreadCount: number
  handleClickNotice: (noticeId: number) => void
}) => {
  return (
    <div className='px-3 pb-32 pt-3'>
      {loading ? (
        <div className='bg-white rounded-2xl shadow-lg overflow-hidden'>
          <div className='p-8 text-center'>
            <div className='inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-amber-600 mb-4'></div>
            <p className='text-gray-500'>알림을 불러오는 중...</p>
          </div>
        </div>
      ) : notices.length > 0 ? (
        <div className=' overflow-hidden'>
          <div className=' py-2'>
            {/* 읽지 않은 메시지 카운트 */}
            {unreadCount > 0 && (
              <div className='mb-4'>
                <p className='text-sm text-gray-600'>읽지 않은 메시지 {unreadCount}개</p>
              </div>
            )}

            <div className='space-y-3'>
              {notices.map(notice => (
                <NoticeListItem
                  key={notice.notice_id}
                  id={notice.notice_id.toString()}
                  title={notice.title}
                  date={notice.created_at}
                  isRead={notice.is_read}
                  handleNoticeClick={() => handleClickNotice(notice.notice_id)}
                  type='공지'
                />
              ))}
            </div>
          </div>
        </div>
      ) : (
        /* 빈 상태 메시지 */
        <div className='bg-white rounded-2xl shadow-lg overflow-hidden'>
          <div className='p-8 text-center'>
            <div className='w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4'>
              <Bell className='w-8 h-8 text-amber-600' />
            </div>
            <h3 className='text-lg font-bold text-gray-700 mb-2'>알림이 없어요</h3>
            <p className='text-sm text-gray-500 leading-relaxed'>
              새로운 알림이 있으면
              <br />
              여기에 표시됩니다
            </p>
          </div>
        </div>
      )}
    </div>
  )
}

export default NoticeListScreen
